// extracted by mini-css-extract-plugin
export default {"content-root":"_2dLyv","contentRoot":"_2dLyv","title":"_1RAp3","message":"_311hs","image":"_2o38V"};